import { apiService } from '../../..'
import { HardshipRequest, PaymentArrangementScheduleResponse } from '../types'

const baseUrl = 'portal/consumers/hardship'

export const hardshipService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    getPaymentArrangementSchedule: build.query<PaymentArrangementScheduleResponse, void>({
      query: () => {
        return {
          url: `${baseUrl}/paynow/schedule`,
          method: 'get',
        }
      },
      providesTags: ['PaymentArrangement'],
    }),
    payHardshipInstallment: build.mutation<void, HardshipRequest>({
      query: (body) => ({
        url: `${baseUrl}/paynow/pay`,
        method: 'post',
        data: body,
      }),
      invalidatesTags: ['AmountDueSummary'],
    }),
  }),
})
